import { endpoint } from 'services/endpoint';
import { http } from 'services/http';
import { fileNameFromContentDisposition } from 'services/api/paymentGateway';
import { TDownloadedReportFile } from 'redux/reducers/reports/types';
import { TReportsApi } from './types';

export const reports: TReportsApi = {
	getReportTypes: () => http.get(endpoint.reports.REPORT_TYPES).then((response) => response.data),
	searchAvailableReports: (payload) =>
		http.post(endpoint.reports.SEARCH_AVAILABLE_REPORTS, payload).then((response) => response.data),
	downloadAvailableReport: ({ id, fallbackFileName }) =>
		http.get<Blob>(endpoint.reports.DOWNLOAD_AVAILABLE_REPORT(id), { responseType: 'blob' }).then(
			(response): TDownloadedReportFile => ({
				blob: response.data,
				fileName: fileNameFromContentDisposition(
					response.headers?.['content-disposition'] as string | undefined,
					fallbackFileName,
				),
			}),
		),
};
